import React from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { Button, Modal } from 'semantic-ui-react'
import { showConfirmModal } from 'ducks/app'

const ConfirmModal = (props) => {
  const { modal: { show, data }, showConfirmModal } = props
  return (
    <Modal open={show}>
      <Modal.Header>{data.header}</Modal.Header>
      <Modal.Content>{data.message}</Modal.Content>
      <Modal.Actions>
        <Button 
          icon={data.cancelIcon || 'cancel'}
          type='button'
          color='red' 
          labelPosition='left' 
          content={data.btnCancelText || 'Close'}
          onClick={() => {
            if (data.onClickCancel) data.onClickCancel()
            showConfirmModal(
              false, {
                header: '', 
                message: '', 
                btnConfirmText: 'Confirm', 
                onClickConfirm: () => {},
                confirmIcon: '',
                btnCancelText: 'Cancel', 
                onClickCancel: () => {},
                cancelIcon: '',
              })
          }} />
        <Button 
          icon={data.confirmIcon || 'checkmark'}
          type='button'
          color='blue' 
          labelPosition='right' 
          content={data.btnConfirmText || 'Confirm'}
          onClick={() => {
            if (data.onClickConfirm) data.onClickConfirm() 
            showConfirmModal(
              false, {
                header: '', 
                message: '', 
                btnConfirmText: 'Confirm', 
                onClickConfirm: () => {}, 
                confirmIcon: '',
                btnCancelText: 'Cancel', 
                onClickCancel: () => {},
                cancelIcon: '',
              })
          }} />
      </Modal.Actions>
    </Modal>
  )
}

const mapStateToProps = (state) => ({
  modal: state.app.confirmModal,
})

const mapDispatchToProps = {
  showConfirmModal
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
)

export default enhance(ConfirmModal)